function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { getMondayConfig } from "/server/services/monday-service/monday-api-service";
import * as Sentry from "@sentry/nextjs";
const BOARD_ID = 3749556763;
const query = `{
  boards(ids: ${BOARD_ID}) {
    items_page (limit: 500) {
      items {
        name
        column_values {
          id
          column{title}
          value
        }
      }
    }
  }
}`;
export default [
    {
        propsPropertyName: "mondayConfig",
        shouldFetch: ()=>{
            return false;
        },
        fetch: /*#__PURE__*/ _async_to_generator(function*() {
            try {
                const mondayConfig = yield getMondayConfig({
                    query,
                    boardId: BOARD_ID
                });
                return mondayConfig;
            } catch (e) {
                Sentry.captureMessage(`What's new embedded component api call failed: ${e.message}`);
                return null;
            }
        })
    }
];
